import { httpsCallable } from 'firebase/functions';
import { functions } from './firebaseService';
import { buildReferralLink } from '../utils/referral';
import { getPendingReferral, clearPendingReferral } from '../utils/referralCapture';

/**
 * Klient-wrappere for verving (#3 Reciprocity). All grant-logikk + svindel-vakter bor
 * server-side (functions/index.js, gated på system/referral_config.enabled). Disse er
 * bare tynne callable-kall. Se docs/plan-ux-principles-retention.md.
 */

const APP_BASE_URL = 'https://app.fricamp.com';

/** Hent min vervekode + ferdig delbar lenke (registrerer kode→uid server-side). */
export async function fetchMyReferralLink(): Promise<{ code: string; link: string }> {
  const callable = httpsCallable<Record<string, never>, { code: string }>(functions, 'getMyReferralCode');
  const { data } = await callable({});
  return { code: data.code, link: buildReferralLink(APP_BASE_URL, data.code) };
}

/**
 * Meld inn en ventende vervekode (fra ?ref) etter at brukeren har opprettet konto.
 * Kalles én gang etter innlogging. Rydder den ventende koden uansett utfall (også ved
 * feil/avslag) så vi ikke prøver i evighet. No-op hvis ingen ventende kode.
 */
export async function claimPendingReferral(): Promise<{ ok: boolean; reason?: string } | null> {
  const code = getPendingReferral();
  if (!code) return null;
  try {
    const callable = httpsCallable<{ code: string }, { ok: boolean; reason?: string; granted?: boolean }>(functions, 'claimReferral');
    const { data } = await callable({ code });
    return data;
  } catch (e: any) {
    // failed-precondition (verving av) eller nettverksfeil — ikke kritisk.
    return { ok: false, reason: e?.code || 'error' };
  } finally {
    clearPendingReferral();
  }
}
